import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Dashboard from "@/pages/Dashboard";
import MenuManagement from "@/pages/MenuManagement";
import AIAssistant from "@/pages/AIAssistant";
import Analytics from "@/pages/Analytics";
import Settings from "@/pages/Settings";
import Billing from "@/pages/Billing";
import Promotions from "@/pages/Promotions";
import PublicMenu from "@/pages/PublicMenu";
import AdminPanel from "@/pages/AdminPanel";
import DashboardLayout from "@/components/DashboardLayout";
import MentionsLegales from "@/pages/MentionsLegales";
import CGU from "@/pages/CGU";
import Confidentialite from "@/pages/Confidentialite";
import TakeawayOrders from "@/pages/TakeawayOrders";
import OrderTracking from "@/pages/OrderTracking";
import Explorer from "@/pages/Explorer";
import Boost from "@/pages/Boost";
import LoyaltyManagement from "@/pages/LoyaltyManagement";
import LoyaltyCards from "@/pages/LoyaltyCards";
import TableManagement from "@/pages/TableManagement";
import OrdersDashboard from "@/pages/OrdersDashboard";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" /></div>;
  if (!user) return <Navigate to="/login" />;
  return children;
};

const OwnerRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" /></div>;
  if (!user) return <Navigate to="/login" />;
  if (user.role === 'user') return <Navigate to="/my-loyalty" />;
  return children;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" /></div>;
  if (!user || user.role !== "admin") return <Navigate to="/dashboard" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/m/:slug" element={<PublicMenu />} />
          <Route path="/explorer" element={<Explorer />} />
          <Route path="/order/:trackingToken" element={<OrderTracking />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgu" element={<CGU />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          
          {/* Protected routes */}
          <Route path="/dashboard" element={<OwnerRoute><DashboardLayout><Dashboard /></DashboardLayout></OwnerRoute>} />
          <Route path="/menu" element={<OwnerRoute><DashboardLayout><MenuManagement /></DashboardLayout></OwnerRoute>} />
          <Route path="/promotions" element={<OwnerRoute><DashboardLayout><Promotions /></DashboardLayout></OwnerRoute>} />
          <Route path="/ai" element={<OwnerRoute><DashboardLayout><AIAssistant /></DashboardLayout></OwnerRoute>} />
          <Route path="/analytics" element={<OwnerRoute><DashboardLayout><Analytics /></DashboardLayout></OwnerRoute>} />
          <Route path="/settings" element={<OwnerRoute><DashboardLayout><Settings /></DashboardLayout></OwnerRoute>} />
          <Route path="/billing" element={<OwnerRoute><DashboardLayout><Billing /></DashboardLayout></OwnerRoute>} />
          <Route path="/takeaway" element={<OwnerRoute><DashboardLayout><TakeawayOrders /></DashboardLayout></OwnerRoute>} />
          <Route path="/boost" element={<OwnerRoute><DashboardLayout><Boost /></DashboardLayout></OwnerRoute>} />
          <Route path="/loyalty" element={<OwnerRoute><DashboardLayout><LoyaltyManagement /></DashboardLayout></OwnerRoute>} />
          <Route path="/tables" element={<OwnerRoute><DashboardLayout><TableManagement /></DashboardLayout></OwnerRoute>} />
          <Route path="/orders" element={<OwnerRoute><DashboardLayout><OrdersDashboard /></DashboardLayout></OwnerRoute>} />
          <Route path="/my-loyalty" element={<ProtectedRoute><DashboardLayout><LoyaltyCards /></DashboardLayout></ProtectedRoute>} />
          
          {/* Admin routes */}
          <Route path="/admin" element={<AdminRoute><DashboardLayout><AdminPanel /></DashboardLayout></AdminRoute>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
